<div class="container-fluid px-2">

    <!-- First Row: Search + Select -->
    <div class="row gy-2 align-items-center mb-2">

        <!-- Search Input -->
        <div class="col-md-6">
            <input type="text" class="form-control form-control-sm shadow-sm" placeholder="Type to filter by name..."
                (keyup)="updateFilter($event)" />
        </div>

        <!-- Customer Select -->
        <div class="col-md-6">
            <ng-select class="w-100 " [searchable]="true" [clearable]="true" [appendTo]="'body'"
                placeholder="Select Customer" (change)="getOrderByCustomerId($event)">
                <ng-option [value]="null">All</ng-option>
                <ng-option *ngFor="let customer of customerList" [value]="customer._id">
                    #{{ customer.customerAutoId }} - {{ customer.name }}
                </ng-option>
            </ng-select>
        </div>

    </div>

    <!-- Second Row: Action Buttons -->
    <div class="row">
        <div class="col-12 d-flex flex-wrap gap-2">
            <button class="btn btn-sm px-3"
                [ngClass]="activeFilter === 'guidance' ? 'btn-success' : 'btn-outline-success'"
                (click)="onFilterClick('guidance')">
                Guidance
            </button>

            <button class="btn btn-sm px-3" [ngClass]="activeFilter === 'chat' ? 'btn-primary' : 'btn-outline-primary'"
                (click)="onFilterClick('chat')">
                Chat
            </button>

            <button class="btn btn-sm px-3" [ngClass]="activeFilter === 'query' ? 'btn-warning' : 'btn-outline-warning'"
                (click)="onFilterClick('query')">
                Query
            </button>

            <button class="btn btn-sm px-3" [ngClass]="activeFilter === 'report' ? 'btn-info' : 'btn-outline-info'"
                (click)="onFilterClick('report')">
                Report
            </button>
        </div>
    </div>


</div>



<br>
<ngx-datatable class="material" [rows]="orderList" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
    [rowHeight]="'auto'" [scrollbarV]="false" [limit]="10" [sorts]="[{dir: 'desc'}]"
    style="position: relative !important;">
    <ngx-datatable-column [flexGrow]="1" name="Order ID" prop="oserviceId">
        <ng-template let-row="row" ngx-datatable-cell-template>
            #{{row.oserviceId}}
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="2" name="Order Type">
        <ng-template let-row="row" ngx-datatable-cell-template>
            @if (row.is_chat_order) {
            <span class="rounded-1 px-1 text-bg-primary">Chat</span>
            }
            @if (row.is_call_order) {
            <span class="rounded-1 px-1 text-bg-secondary">Call</span>
            }
            @if (row.is_report_order) {
            <span class="rounded-1 px-1 text-bg-info">Report</span>
            }
            @if (row.is_query_order) {
            <span class="rounded-1 px-1 text-bg-warning">Query</span>
            }
            @if (row.isGuidanceOrder) {
            <span class="rounded-1 px-1 text-bg-success">Guidance</span>
            }
        </ng-template>

    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="1" name="Amount">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <span *ngIf="row.is_chat_order">{{row.chatId?.customerCurrencySymbol}}{{row.chatId?.customer_amount |number
                : '.2-2'}}</span>
            <span *ngIf="row.is_call_order">{{row.callId?.customerCurrencySymbol}}{{row.callId?.customer_amount |number
                : '.2-2'}}</span>
            <span *ngIf="row.is_report_order">{{row.reportId?.customerCurrencySymbol}}{{row.reportId?.customer_amount
                |number : '.2-2'}}</span>

            <span *ngIf="row.is_query_order">{{row.queryId?.customerCurrencySymbol}}{{row.queryId?.customer_amount
                |number : '.2-2'}}</span>


            <span *ngIf="row.isGuidanceOrder">{{row.guidanceId?.customerCurrencySymbol}}{{row.guidanceId?.company_amount
                |number : '.2-2'}}</span>


        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="2" name="Astrologer" prop="astroId.name">
        <ng-template let-row="row" ngx-datatable-cell-template>

            @if (row.astroId) {
            <a class="text-dark" [routerLink]="['/admin/astrologers/viewAstrologer', row.astroId._id]">
                <span [title]="row.astroId.name">
                    #{{ row.astroId.astroAutoId }} -
                    {{
                    row.astroId.displayname === '' || row.astroId.displayname == null
                    ? row.astroId.name
                    : row.astroId.displayname
                    }}
                </span>
            </a>
            } @else {
            <span>-</span>
            }

        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="2" name="Customer" prop="customerId.name">
        <ng-template let-row="row" ngx-datatable-cell-template>
            <a class="text-dark"
                [routerLink]="['/admin/customers/viewCustomer',row.customerId?._id,'detail']">#{{row.customerId?.customerAutoId}}-{{row.customerId?.name}}</a>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="1" name="Action">
        <ng-template let-row="row" ngx-datatable-cell-template>

            <a *ngIf="row.is_query_order" [routerLink]="['/admin/orders/query/', row.queryId?._id]"
                title="View Details"><i class="fa fa-eye"></i></a>
            <a *ngIf="row.is_call_order" title="View Details" [routerLink]="['/admin/orders/call/', row.callId?._id]"><i
                    class="fa fa-eye"></i></a>
            <a *ngIf="row.is_chat_order" title="View Details" [routerLink]="['/admin/orders/chat/', row.chatId?._id]"><i
                    class="fa fa-eye"></i></a>

            <a *ngIf="row.is_report_order" [routerLink]="['/admin/orders/report/', row.reportId?._id]"
                title="View Details"><i class="fa fa-eye"></i></a>

            <a *ngIf="row.isGuidanceOrder" [routerLink]="['/admin/orders/guidance/', row?.guidanceId?._id]"
                title="View Details"><i class="fa fa-eye"></i></a>

        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="3" name="Date" prop="created_at">
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.created_at |date :'medium'}}
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>